<template>
  <Container type="card-full">
    <!-- 搜索 -->
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">协议编号</div>
          <div class="field">
            <el-input v-model.trim="query.ptccode" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">协议名称</div>
          <div class="field">
            <el-input v-model.trim="query.ptcname" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">采购人</div>
          <div class="field">
            <el-input v-model.trim="query.ptccomname" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">业务员</div>
          <div class="field">
            <el-input v-model.trim="query.ptcUsername" clearable></el-input>
          </div>
        </div>
        
        <div class="searchItem">
          <div class="label">交易方式</div>
          <div class="field">
            <el-select
              v-model="query.ptctrademode"
              :clearable="true"
              placeholder="请选择"
            >
              <el-option
                v-for="item in ptcPrsflgList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">状态</div>
          <div class="field">
            <el-select
              v-model="query.ptcstatus"
              :clearable="true"
              placeholder="请选择"
            >
              <el-option
                v-for="item in ptcstatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">建项</div>
          <div class="field">
            <el-select
              v-model="query.ptcuse"
              :clearable="true"
              placeholder="请选择"
            >
              <el-option
                v-for="item in ptcUseList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">协议日期</div>
          <div class="field" style="width: 400px">
            <el-date-picker
              v-model="query.ptcbegTime"
              type="date"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
            <div style="margin: 0 10px">至</div>
            <el-date-picker
              v-model="query.ptcendTime"
              type="date"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button type="primary" @click="search">查询</el-button>
          </div>
        </div>
      </div>
    </div>

    <vggrid
      :list="list"
      tableheight="700"
      flexname=""
      :cols="cols"
      :showfooter="false"
      :showPage="true"
      :resizable="true"
      :total="query.total"
      @cellClick="cellClick"
      @cellDblClick="viewProject"
      @pagechange="pagechange"
      :defaultPage="10"
      :isOperate="btn.isOperate"
      :operateBtn="btn.right"
      @vggridClick="vggridClick"
    >
      <template slot="btn">
        <menu-btn
          :menuid="menuid"
          @btnClick="btnClick"
          @btnmenuclick="btnmenuclick"
        ></menu-btn>
      </template>
    </vggrid>
  </Container>
</template>
<script>
import request from "@/utils/request";
import MenuBtn from "../common/menuBtn";
import vggrid from "../common/vggrid";
import dayjs from "dayjs";
import utils from "../../assets/js/utils";
export default {
  name: "ptcIndex",
  data() {
    return {
      menuid: this.$route.query.menuid,
      btn: {},
      ptc: {},
      dptList: [],
      ptcstatusList: [],
      ptcPrsflgList: [],
      cols: [
        {
          type: "seq",
          fieldtype: "I",
          title: "行号",
          calculExpr: "",
          width: 80,
        },
        {
          field: "ptccode",
          fieldtype: "C",
          title: "协议编号",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "ptcname",
          fieldtype: "C",
          title: "协议名称",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "ptcpcomname",
          fieldtype: "C",
          title: "采购人",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "ptcbudgetamtdesc",
          fieldtype: "C",
          title: "协议预算",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "ptctrademodeflg",
          fieldtype: "C",
          title: "交易方式",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "ptccreatename",
          fieldtype: "C",
          title: "业务员",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "dptname",
          fieldtype: "C",
          title: "项目分派",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "ptcstatusdesc",
          fieldtype: "C",
          title: "状态",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "ptchasimplement",
          fieldtype: "C",
          title: "建项",
          calculExpr: "",
          addNewRowFlg: false,
          align: "center" 
        },
        {
          field: "ptccreatetime",
          fieldtype: "C",
          title: "协议日期",
          calculExpr: "",
          addNewRowFlg: false,
          formatter: ["toDateString", "yyyy-MM-dd"],
          width: 100,
        },
      ],
      list: [],
      ptcUseList:[],
      isOperate: true,
      query: {
        cosid: this.$store.getters.loginUser.cosid,
        ptcdptid: this.$store.getters.loginUser.userdptid,
        ptccreateuserid: this.$store.getters.loginUser.userid,
        comid: this.$store.getters.loginUser.comid,
        total: 0,
        limit: 10,
        offset: 0,
      },
    };
  },
  components: { MenuBtn, vggrid },
  created() {
    this.$on("ADD", () => this.addptc());
    this.$on("CHG", () => this.chgptc());
    this.$on("DEL", () => this.delptc());
  },
  async activated() {
    await this.getPageList();
    await this.getDptList();
    await this.getptcstatusList();
    await this.getprsflgList();
    await this.getPtcuseList()
  },
  methods: {
    btnClick(code) {
      this.$emit(code);
    },
    vggridClick(code, row) {
      this.ptc = row;
      this.$emit(code, row);
    },
    btnmenuclick(btn) {
      this.btn = btn;
    },
    async viewProject(row) {
      this.ptc = row.row;
      this.$router.push({
        name: "ptcview",
        params: { ptcid: this.ptc.ptcid, type: 1 },
      });
    },
    async cellClick(row) {
      this.ptc = row.row;
    },
    async pagechange(page) {
      this.query.offset = page.pageSize * (page.currentPage - 1);
      this.query.limit = page.pageSize;
      this.getPageList();
    },
    async search() {
      this.query.offset = 0;
      if (!this.query.ptcdptid) {
        this.query.ptcdptid = this.$store.getters.loginUser.userdptid;
      }
      if (this.query.ptcendTime) {
        this.query.ptcendtime = dayjs(this.query.ptcendTime)
          .add(1, "day")
          .format("YYYY-MM-D");
      }
      this.getPageList();
    },
    async getPageList() {
      this.loading = true;
      let res = await request({
        url: "/xmgl/ptc/getptcList",
        method: "get",
        params: this.query,
      });
      this.list = res.list;
      res.list.map((e) => {
        e.ptcbudgetamtdesc = e.ptcbudgetamt
          ? utils.comdify(e.ptcbudgetamt)
          : e.ptcbudgetamt;
        e.ptchasimplement = e.ptchasimplementCount > 0 ? "己建项" : "未建项";
      });
      this.query.total = res.count[0].count;
      this.loading = false;
    },
    async addptc() {
      this.$router.push({ name: "ptcform", params: { ptcid: 0, type: 1 } });
    },
    async chgptc() {
      if (!this.ptc.ptcid) {
        this.$message.warning("请选择一个项目!");
        return;
      }
      if (+this.ptc.ptcstatus === 1) {
        this.$message.warning("协议已提交，不可更改");
        return;
      }
      this.$router.push({
        name: "ptcEdit",
        params: { ptcid: this.ptc.ptcid, type: 1 },
      });
    },
    async delptc(row) {
      if (!this.ptc.ptcid) {
        this.$message.warning("请选择一个项目!");
        return;
      }
      if (+this.ptc.ptcstatus === 1) {
        this.$message.warning("协议已提交，不可删除");
        return;
      }
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let res = await request({
          url: "/xmgl/ptc/delptc",
          method: "post",
          data: { ptcid: this.ptc.ptcid },
        });
        if (res.issuccess === 1) {
          this.$message.success("删除成功");
          await this.getPageList();
          return;
        }
      });
    },
    async getDptList() {
      //获取部门
      this.dptList = await request({
        method: "get",
        url: "/xtgl/dpt/getDptList",
        params: { comid: this.$store.getters.loginUser.comid },
      });
    },
    async getPtcuseList() {
      //获取状态
      this.ptcUseList = await request({
        url: "/kfgl/syscode/getSysCodeList",
        method: "get",
        params: { syscode: "ptcuse" },
      });
    },
    async getptcstatusList() {
      //获取状态
      this.ptcstatusList = await request({
        url: "/kfgl/syscode/getSysCodeList",
        method: "get",
        params: { syscode: "ptcstatus" },
      });
    },
    async getprsflgList() {
      //获取交易方式
      this.ptcPrsflgList = await request({
        url: "/kfgl/syscode/getSysCodeList",
        method: "get",
        params: { syscode: "prsflg" },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
